import { useSelector } from "react-redux";
import { ApplicationState } from "../store";

export function GetCountryListAndInternationalSupport() {
    const supportInternational = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration && state.configurationState.configuration.partnerConfig) {
            return {
                supportInternational: state.configurationState.configuration.partnerConfig.supportInternational,
            };
        } else {
            return {
                supportInternational: false,
            };
        }
    });
    const getCountries = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.countryList) {
            let extra: any = [];
            let remainingCountry = state.configurationState.countryList.filter((country) => {
                if (country.countryCode === "US") {
                    extra.unshift(country);
                    return false;
                }
                if (country.countryCode === "CA") {
                    extra.push(country);
                    return false;
                }
                return true;
            });
            return {
                countryList: extra.concat(remainingCountry.sort((a, b) => (a.name > b.name ? 1 : -1))),
            };
        } else {
            return {
                countryList: [],
            };
        }
    });

    return { supportInternational: supportInternational.supportInternational, getCountries };
}
export const GetCountryAndInternationalPhoneNumber = () => {
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const internationalPhoneNumber = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.internationalPhoneNumber
            ? state.configurationState.configuration.partnerConfig.internationalPhoneNumber
            : ""
    );
    let currentCountry = accountInfo && accountInfo.country ? accountInfo.country : "";
    let isCountryUS = false;
    if (currentCountry.includes("US") || currentCountry === "") {
        isCountryUS = true;
    }
    return { isCountryUS: isCountryUS, internationalPhoneNumber: internationalPhoneNumber };
};
